import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ChartService } from 'src/app/services/chart.service';
import ApexCharts from 'apexcharts';

@Component({
  selector: 'app-accounting-chart-expenses',
  templateUrl: './accounting-chart-expenses.component.html',
  styleUrls: ['./accounting-chart-expenses.component.scss']
})
export class AccountingChartExpensesComponent implements OnInit {
  year = null;
  years = [];
  constructor(
    private chartService: ChartService,
    private toastService: ToastrService
  ) {
    this.year = new Date().getFullYear();
    var origin = 2022;
    for (let index = origin; index <= (this.year + 3); index++) {
      this.years.push(index);
    }
  }

  ngOnInit() {
    this.updateChart();
  }

  updateChart() {
    document.querySelector("#accounting-chart-expenses").innerHTML = "";
    this.chartService.getExpensesChart(this.year).subscribe({
      next: (response: ResponseObject) => {
        var categories = [];
        var data = [];
        response.data.forEach((r) => {
          if (r.total > 0) {
            data.push(r.total)
            categories.push(r.name)
          }
        })
        console.log(data);


        var options = {
          series: [{
            data: data
          }],
          chart: {
            height: 350,
            type: 'bar',
            events: {
              click: function (chart, w, e) {
                // console.log(chart, w, e)
              }
            }
          },
          plotOptions: {
            bar: {
              columnWidth: '45%',
              distributed: true,
            }
          },
          dataLabels: {
            enabled: false
          },
          legend: {
            show: true,
            formatter: function (seriesName, opts) {
              console.log(opts);

              return '<span>' + seriesName + '</span>' +
                '<span><b> Q' + opts.w.globals.series[0][opts.seriesIndex] + '</b></span>';
            }
          },
          xaxis: {
            categories: categories,
            labels: {
              style: {
                fontSize: '12px'
              },
              rotate: 0,
              formatter: function (seriesName, opts) {
                if (typeof opts === "string") {
                  return (opts.length < 17) ? opts : opts.substring(0, 20) + '...';
                } else {
                  return seriesName;
                }
              }
            }
          },
          tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
              console.log(series, seriesIndex, dataPointIndex, w);

              var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];

              return '<div style="padding:0.5em; margin:0;"><p class="h6">' + w.globals.labels[dataPointIndex] + '<span style="color:' + w.globals.colors[dataPointIndex] + ';">⬤</span></p>' +
                '<p class="h4" style="color:' + w.globals.colors[dataPointIndex] + ';"><b>Q ' + series[0][dataPointIndex] + '</b></p></div>';
            }
          }
        };

        var chart = new ApexCharts(document.querySelector("#accounting-chart-expenses"), options);
        chart.render();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }
}
